import { render, staticRenderFns } from "./EventCardTabs.vue?vue&type=template&id=3a765b6d&"
import script from "./EventCardTabs.vue?vue&type=script&lang=js&"
export * from "./EventCardTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports